import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2964855539/src/apps/junonkuji/src/components/ui/Tab/Tab.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2964855539/src/apps/junonkuji/src/features/lottery/components/LotteryInfiniteList/LotteryInfiniteList.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2964855539/src/apps/junonkuji/src/features/lottery/components/LotteryListHeader/LotteryListHeader.tsx");
